<template>
  <div :class="['query-bar', { hide: isShrink }]">
    <el-form :model="query" inline>
      <slot></slot>
    </el-form>

    <div class="query-button">
      <!-- <el-button v-show="isExport" class="bold" @click="outputExcelFile"
        >导出</el-button
      > -->
      <el-button v-if="close" class="bold" @click="onShrinkBar">{{
        isShrink ? '展开' : '收起'
      }}</el-button>
      <el-button class="bold" @click="onClickQuery">查询</el-button>
    </div>
  </div>
</template>

<script>
import { dataListHeight, queryPage } from '@/mixins'
import { mapGetters } from 'vuex'
import tools from '@/utils/tools'
export default {
  name: 'common-query',
  props: {
    query: {
      type: Object,
      default() {
        return {}
      },
      comment: '查询条件'
    },
    close: {
      type: Boolean,
      default() {
        return true
      }
    },
    isExport: Boolean,
    listdata: Array,
    selectdata: Array
  },

  data() {
    return {
      isShrink: false,
      tableList: null,
      queryBar: null,
      expandHeight: 55,
      merId: []
    }
  },

  created() {
    this.onClickQuery()

    this.$once('hook:mounted', () => {
      this.$nextTick(() => {
        const doc = document
        setTimeout(() => {
          this.queryBar = doc.querySelector('.query-bar > .el-form') || {}
          this.tableList = doc.querySelector('.table-list .el-table') || {}
        }, 150)
      })
    })
  },

  methods: {
    onShrinkBar() {
      this.isShrink = !this.isShrink

      const tableStyle = this.tableList.style
      let queryFormHeight = this.queryBar.scrollHeight

      if (!this.isShrink) {
        queryFormHeight = -queryFormHeight
      }

      tableStyle.height = parseInt(tableStyle.height) + queryFormHeight + 'px'
    },

    onClickQuery() {
      this.$emit('query', this.query)
    },

    // T3商户系统审核导出
    exportData() {
      this.listdata.map(item => {
        this.merId.push(item.merId)
      })
      this.merId = this.merId.toString()
      // console.log(this.merId, '导出')

      const {
        merId,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T3/merchantAudit/getExport'

      dispatch(dispatchEvent, { merId }).then(res => {
        console.log(res, '导出')
      })
    },

    // 导出文件
    outputExcelFile() {
      this.$emit('exportdata', true)
      // this.listdata.map(item => {
      //   this.merId.push(item.merId)
      // })
      // this.merId = this.merId.toString()
      // const { dispatch } = this.$store
      // this.showLoading = true
      // dispatch('downloadFile', {
      //   url: '/merSysReview/detail/export',
      //   params: { merId: this.merId }
      // }).then(data => {
      //   tools.downloadFile({
      //     filedata: data,
      //     filename: `批量导出商户详情列表`
      //   })
      //   this.showLoading = false
      // })
      // console.log('导出', this.selectdata)
      // if (this.selectdata.length > 5) {
      //   this.$alert.error(
      //     `总共选择${this.selectdata.length}条数据,最多只能选择5条数据`
      //   )
      //   return
      // }
      // if (this.selectdata.length <= 0) {
      //   this.$alert.error('至少选择一条数据')
      //   return
      // }
      // this.selectdata.map(item => {
      //   this.merId.push(item.merId)
      // })
      // this.merId = this.merId.toString()
      // const { dispatch } = this.$store
      // this.showLoading = true
      // dispatch('downloadFile', {
      //   url: '/merSysReview/detail/export',
      //   params: { merId: this.merId }
      // }).then(data => {
      //   tools.downloadFile({
      //     filedata: data,
      //     filename: `批量导出商户详情列表`
      //   })
      //   this.showLoading = false
      //   this.$alert('数据导出成功').then(res => {
      //     this.$emit('clear', true)
      //   })
      // })
    }
  }
}
</script>

<style lang="scss">
@import '@/css/Common/queryBar.scss';
</style>
